<template>
  <div v-if="isShow" class="popup_complete" style="width: 438px">
    <!--예약취소시 3초간 보여짐-->
    <p>{{ content }}</p>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  name: "BaseToast",
  setup() {
    let isShow = ref(false);
    let content = ref(null);

    const showToast = (message) => {
      isShow.value = true;
      content.value = message;
      setTimeout(() => {
        isShow.value = false;
      }, 3000);
    };
    return { isShow, content, showToast };
  },
};
</script>
